import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { API_HANDLERS } from 'api/apiHandlers';
import { alert } from 'components';

export function useCreateFileMutation() {
  const queryClient = useQueryClient();
  const { t } = useTranslation();

  const { mutateAsync: createFileMutation, isLoading } = useMutation(
    (data: FormData) => API_HANDLERS.FILES.CREATE(data),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['files']);
        alert.success(t('toasts.file.success.create'));
      },
      onError: () => {
        alert.error(t('toasts.file.error.create'));
      },
    },
  );

  return { createFileMutation, isLoading };
}
